/**
 * Extract a human-readable error message from an Axios error object.
 *
 * Handles these shapes returned by FastAPI:
 * 1. `{ detail: "string" }` — most common, returned by `HTTPException(detail=...)`
 * 2. `{ detail: [{ type, loc, msg, input, url }, ...] }` — returned for 422
 *    Pydantic validation errors. Rendering this directly in React throws
 *    "Objects are not valid as a React child".
 * 3. `{ detail: { ... } }` — fallback, render JSON.
 *
 * @param {unknown} error  Axios/fetch error.
 * @param {string} fallback  Human-readable fallback message.
 * @returns {string} Always a plain string safe for `toast.error()` / JSX.
 */
export const extractErrorMessage = (error, fallback = 'Terjadi kesalahan') => {
  const detail = error?.response?.data?.detail;

  if (!detail) {
    return error?.message || fallback;
  }

  if (typeof detail === 'string') {
    return detail;
  }

  if (Array.isArray(detail)) {
    // FastAPI validation errors: turn into "field: msg" lines.
    return detail
      .map((d) => {
        const loc = Array.isArray(d?.loc) ? d.loc.filter((x) => x !== 'body').join('.') : '';
        const msg = d?.msg || 'invalid';
        return loc ? `${loc}: ${msg}` : msg;
      })
      .join('; ');
  }

  // Object — last resort
  try {
    return JSON.stringify(detail);
  } catch {
    return fallback;
  }
};

export default extractErrorMessage;
